import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '../locales/en.json'
import fr from '../locales/fr.json'

Vue.use(VueI18n)

export const local = document.head.querySelector(
  'meta[name="app-locale"]'
).content
export const languages = {
  fr: fr,
  en: en,
}
const messages = Object.assign(languages)
const i18n = new VueI18n({
  locale: local,
  messages,
})
export default i18n
